import { useState, type ReactNode } from 'react';

import { DiscardChangesDialog } from '@/shared/components/DiscardChangesDialog';

/**
 * Ask before throwing typed input away (spec 129 FR-006).
 *
 * A sheet's close — Esc, a click outside, the close button — goes through
 * `requestClose`. Untouched, it closes at once; with changes, an in-app
 * confirmation asks first, Keep editing being the default. Render `dialog`
 * beside the sheet.
 */
export function useDiscardGuard(
  dirty: boolean,
  close: () => void,
): { requestClose: () => void; dialog: ReactNode } {
  const [asking, setAsking] = useState(false);
  const requestClose = () => {
    if (dirty) setAsking(true);
    else close();
  };
  const dialog = (
    <DiscardChangesDialog
      open={asking}
      onDiscard={() => {
        setAsking(false);
        close();
      }}
      onKeep={() => {
        setAsking(false);
      }}
    />
  );
  return { requestClose, dialog };
}
